import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Table, Tooltip } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { Catcher, LinkComponent, LoadingApiByIds, ShowDataBytes, columnToolbar } from '../../';
import { IPackageInfo } from '../../../interfaces';
import { usePackagesForSale, useRouterStore } from '../../../hooks';
import { tF, tI } from '../../../translate';
import Styles from '../../SubComponents/m_styles.less';
import ViewStyles from '../../styles/m_viewStyles.less';

export const TableForBuy: React.FC = observer(() => {
    const routerStore = useRouterStore();
    const data = usePackagesForSale();

    const tableColumns = [
        {
            title: tF('Package name'),
            dataIndex: 'packageLink',
        },
        {
            title: tF('Offered By'),
            dataIndex: 'companyLink',
        },
        {
            title: tF('Price'),
            dataIndex: 'price',
            className: ViewStyles.columnRight,
        },
        {
            title: tF('Currency'),
            dataIndex: 'currencyName',
        },
        {
            title: tF('Data volume'),
            dataIndex: 'showDataVolume',
            className: ViewStyles.columnRight,
        },
        {
            title: tF('Duration'),
            dataIndex: 'monthDurationName',
        },
        {
            title: tF('Zone'),
            dataIndex: 'zoneLink',
        },
        {
            title: tF('Credit Remains'),
            dataIndex: 'creditRemainsName',
        },
        columnToolbar,
    ];

    const goTo = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>, id: string): void => {
        event.preventDefault();
        routerStore.goTo('PackageInstanceBuy', { params: { id } }).then();
    };

    const tableData = data?.map(({ name, id, companyId, companyName, ...p }: IPackageInfo) => {
        return {
            key: id,
            ...p,
            showDataVolume: <ShowDataBytes bytes={p.dataVolumeByte} isHumanView noDataText={'Unlimited'} />,
            packageLink: <LinkComponent currentListComponent={'PackagesUnitsLogsList'} id={id} name={name} />,
            companyLink: <LinkComponent currentListComponent={'CompaniesList'} id={companyId} name={companyName} />,
            zoneLink: <LinkComponent currentListComponent={'ZonesList'} id={p.zoneId} name={p.zoneName} />,
            toolbar: id ? (
                <Tooltip title={`${tI('Buy')} ${name}`}>
                    <a onClick={(e): void => goTo(e, id ? id : '')}>
                        <ShoppingCartOutlined className={Styles.button} />
                    </a>
                </Tooltip>
            ) : null,
        };
    });

    return (
        <Catcher>
            <div>
                <LoadingApiByIds idSpinners={['GET_PACKAGES_TO_BUY']} />
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
